<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Kidney Specific Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="stagedKidney"
              disabled
              label="Staged Kidney"
              :class="{ highlightField: isDifferent(stagedKidney, stagedKidneyOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="stagedKidneyOATS"
              disabled
              label="Staged Kidney"
            />
          </div>
        </div>
    

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="kidneyPairedDonation"
              disabled
              label="Kidney Paired Donations"
              :class="{ highlightField: isDifferent(kidneyPairedDonation, kidneyPairedDonationOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="kidneyPairedDonationOATS"
              disabled
              label="Kidney Paired Donations"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="preEmptive"
              disabled
              label="Pre-Emptive"
              :class="{ highlightField: isDifferent(preEmptive, preEmptiveOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="preEmptiveOATS"
              disabled
              label="Pre-Emptive"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "KidneySpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      stagedKidney: this.getStagedKidney( this.patientBundle ),
      kidneyPairedDonation: this.getKidneyPairedDonation( this.patientBundle ),
      preEmptive: this.getPreEmptive( this.patientBundle ),
      stagedKidneyOATS: this.getStagedKidneyOATS( this.patientBundleOATS, this.patientBundle ),
      kidneyPairedDonationOATS: this.getKidneyPairedDonationOATS( this.patientBundleOATS, this.patientBundle ),
      preEmptiveOATS: this.getPreEmptiveOATS( this.patientBundleOATS, this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataBooleanCheckedLabel( patientBundle, observationCode ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return;
      }
      const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
      if( !match[0] ) {
        return;
      }
      return _.get( match[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
    },
    getEpisodePhase( patientBundle ) {
      if ( !patientBundle?.entries ) {
        return;
      }
      let episodeOfCares = patientBundle.entries.filter( ( n ) => (
        _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' 
      ) );
      if ( !( episodeOfCares?.[0]?.[0] ) ) {
        return;
      }
      const episodeOfCare = episodeOfCares[0].filter( ( n ) => ( _.get( n, 'resource.id' ) === patientBundle.episode_id ) );
      if ( !( episodeOfCare ) ) {
        return;
      }
      const extensions = episodeOfCare?.[ 0 ]?.resource?.extension;
      if ( !extensions ) {
        return;
      }
      for ( const item of extensions ) {
        if ( item.url?.includes( 'transplant-phase-status' ) && item.extension?.length ) {
          const phaseExt = item.extension.filter( ( ext ) => ext.url === 'phase' );
          if ( phaseExt?.[0] ) {
            return _.get( phaseExt[0], 'valueCodeableConcept.coding[0].code' );
          }
        }
      }
    },
    getStagedKidney( patientBundle ) {
      return this.getSmartdataBooleanCheckedLabel( patientBundle, 'UHN#3995' );
    },
    getKidneyPairedDonation( patientBundle ) {
      return this.getSmartdataBooleanCheckedLabel( patientBundle, 'UHN#3996' );
    },
    getPreEmptive( patientBundle ) {
      return this.getSmartdataBooleanCheckedLabel( patientBundle, 'UHN#3567' );
    },
    getStagedKidneyOATS( patientBundleOATS, patientBundle ) {
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) ); 
      let stagedKidney = '';
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            stagedKidney = _.get( journey?.[ 0 ], 'organ_specific_details.staged_kidney', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            stagedKidney = _.get( journey?.[ 0 ], 'organ_specific_details.staged_kidney', '' );
          } 
        }
        if( journey.length === 1 ) {
        stagedKidney = journey[ 0 ].organ_specific_details?.staged_kidney;
        }
      }
      if( stagedKidney == null || stagedKidney === '' ) 
      return '';
      return stagedKidney ? 'Checked' : 'Unchecked';
    },
    getKidneyPairedDonationOATS( patientBundleOATS, patientBundle ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      let kidneyPairedDonation = '';
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            kidneyPairedDonation = _.get( journey?.[ 0 ], 'recipient_program.kidney_paired_donation', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            kidneyPairedDonation = _.get( journey?.[ 0 ], 'recipient_program.kidney_paired_donation', '' );
          } 
        } 
        if( journey.length === 1 ) {
          kidneyPairedDonation = journey[ 0 ].recipient_program?.kidney_paired_donation;
        }
      }
      if( kidneyPairedDonation == null || kidneyPairedDonation === '' ) 
      return '';
      return kidneyPairedDonation ? 'Checked' : 'Unchecked';
    },
    getPreEmptiveOATS( patientBundleOATS, patientBundle ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let preEmptive = '';
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            preEmptive = _.get( journey?.[ 0 ], 'organ_specific_details.pre_emptive_gfr', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            preEmptive = _.get( journey?.[ 0 ], 'organ_specific_details.pre_emptive_gfr', '' );
          } 
        } 
        if( journey.length === 1 ) {
          preEmptive = journey[ 0 ].organ_specific_details?.pre_emptive_gfr;
        }
      }
      if( preEmptive == null || preEmptive === '' ) 
      return '';
      return preEmptive ? 'Checked' : 'Unchecked';
    },
    isDifferent( a, b ) {
      return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
  },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 450px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}

</style>
